/* eslint-disable react-hooks/exhaustive-deps */

import { COLOR_PRIMARY, COLOR_SECONDARY, COLOR_WARNING } from 'styles/theme';
import { UPDATE_HOMESALE_INFO_FAILURE } from 'modules/authorizations/store/types/homesaleTypes';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { formatMoney } from 'utilities/currencyFormatter';
import { postHomesaleInfo, updateHomesaleInfo, updateSpreadSelection } from 'modules/authorizations/store/actions/homesale.actions';
import { showToast } from 'modules/layout/layout.actions';
import React, { useEffect, useState } from 'react';

import { Box, Button, Card, CardContent, Checkbox, Dialog, DialogActions, Fab, Grid, Stack, Tooltip, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { makeStyles } from '@material-ui/styles';
import Spinner from 'modules/common/spinner.component';

const useStyles = makeStyles(theme => ({
  card: {
    width: '100%',
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  cardContainer: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  iconRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  dialogIconRow: {
    display: 'flex',
    flexDirection: 'row',
    padding: '40px',
    paddingBottom: '20px'
  },
  cardDisplayContent: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    margin: '10px'
  },
  chip: {
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  chipClickable: {
    cursor: 'pointer'
  },
  iconOverlayImg: {
    position: 'absolute',
    zIndex: '1 !important'
  },
  spacingX: {
    marginRight: theme.spacing(1)
  },
  footer: {
    height: 15,
    marginBottom: theme.spacing(2)
  },
  mb2: {
    marginBottom: '4px',
    marginRight: '16px'
  },
  editModalContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100% !important',
    marginLeft: '0px !important'
  },
  editModalColumn: {
    display: 'flex',
    flexDirection: 'column',
    width: '100% !important'
  },
  editModalInput: {
    minWidth: '332px'
  },
  dialogContentContainer: {
    margin: '15px',
    paddingLeft: '50px',
    paddingRight: '50px'
  },
  labelText: {
    minWidth: 350,
    marginBottom: 0
  }
}));

const EditCardModal = props => {
  const {
    open,
    onSubmit,
    isLoading,
    onClose,
    homesaleInfo,
    appraisalsBmas,
    appraisalsSelected,
    groupAppraisals,
    statusOptions,
    vendors,
  } = props;
  const classes = useStyles();

  const [bmaSpreadSelectionStart, setBmaSpreadSelectionStart] = useState(homesaleInfo ? homesaleInfo.bmaSpreadSelectionStart : null);
  const [bmaSpreadSelectionEnd, setBmaSpreadSelectionEnd] = useState(homesaleInfo ? homesaleInfo.bmaSpreadSelectionEnd : null);
  const [appraisalSpreadSelectionStart, setAppraisalSpreadSelectionStart] = useState(
    homesaleInfo ? homesaleInfo.appraisalSpreadSelectionStart : null
  );
  const [appraisalSpreadSelectionEnd, setAppraisalSpreadSelectionEnd] = useState(
    homesaleInfo ? homesaleInfo.appraisalSpreadSelectionEnd : null
  );

  const [isDirty, setIsDirty] = useState(false);

  const onSubmitModal = e => {
    e.preventDefault();

    let values = {};

    values.appraisalSpreadSelectionStart = appraisalSpreadSelectionStart;
    values.appraisalSpreadSelectionEnd = appraisalSpreadSelectionEnd;
    values.bmaSpreadSelectionStart = bmaSpreadSelectionStart;
    values.bmaSpreadSelectionEnd = bmaSpreadSelectionEnd;

    onSubmit(values);
  };

  const checkedSpread = (e, group) => {
    if (appraisalsSelected) {
      if (e.target.checked) {
        setAppraisalSpreadSelectionStart(group[0].homesaleAppraisalId);
        setAppraisalSpreadSelectionEnd(group[1].homesaleAppraisalId);
      } else {
        setAppraisalSpreadSelectionStart(null);
        setAppraisalSpreadSelectionEnd(null);
      }
    } else {
      if (e.target.checked) {
        setBmaSpreadSelectionStart(group[0].homesaleAppraisalId);
        setBmaSpreadSelectionEnd(group[1].homesaleAppraisalId);
      } else {
        setBmaSpreadSelectionStart(null);
        setBmaSpreadSelectionEnd(null);
      }
    }
  };

  useEffect(() => {
    if (homesaleInfo) {
      if (
        bmaSpreadSelectionStart !== homesaleInfo.bmaSpreadSelectionStart ||
        bmaSpreadSelectionEnd !== homesaleInfo.bmaSpreadSelectionEnd ||
        appraisalSpreadSelectionStart !== homesaleInfo.appraisalSpreadSelectionStart ||
        appraisalSpreadSelectionEnd !== homesaleInfo.appraisalSpreadSelectionEnd
      ) {
        setIsDirty(true);
      }
    }
  }, [bmaSpreadSelectionStart, bmaSpreadSelectionEnd, appraisalSpreadSelectionStart, appraisalSpreadSelectionEnd]);

  return (
    <Dialog open={open} fullWidth={true} maxWidth={'lg'}>
      <form onSubmit={onSubmitModal} fullScreen>
        <div className="row justify-space-between align-center">
          <div className={classes.dialogIconRow}>
            <Tooltip title="Move Dates" key="Move Dates" placement="right">
              <FontAwesomeIcon icon={['fas', 'money-bill-trend-up']} size="3x" />
            </Tooltip>
            <Typography variant="h5" sx={{ paddingLeft: '20px' }}>
              Spread Selection
            </Typography>
          </div>
        </div>
        <div className={classes.dialogContentContainer}>
          <Stack
            sx={{
              width: '100%',
              minWidth: { xs: '300px', sm: '360px', md: '400px', lg: '400px' },
              gap: '1.5rem'
            }}
          >
            <Grid container spacing={2}>
              <Grid item md="2">
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                      Codes
                    </Typography>
                  </div>
                </Box>
              </Grid>
              <Grid item md="3">
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                      Name
                    </Typography>
                  </div>
                </Box>
              </Grid>
              <Grid item md="2">
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                      {appraisalsSelected ? 'Appraised Value' : 'MLSP'}
                    </Typography>
                  </div>
                </Box>
              </Grid>
              {!appraisalsSelected && (
                <Grid item md="3">
                  <Box>
                    <div className={classes.mb2}>
                      <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                        SLP
                      </Typography>
                    </div>
                  </Box>
                </Grid>
              )}
              <Grid item md={appraisalsSelected ? '5' : '2'}>
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                      Status
                    </Typography>
                  </div>
                </Box>
              </Grid>

              {appraisalsBmas.length > 0 &&
                appraisalsBmas
                  .filter(
                    a =>
                      a.appraisalTypeId ===
                      (appraisalsSelected ? '1bc0f499-6ed9-4400-b777-fc660f69b68c' : '1ab09957-1ae8-4463-aba7-8ac96cc0b427')
                  )
                  .map(a => {
                    const appraiserInfo = vendors.find(b => b.vendorId === a.vendorId);

                    return (
                      <>
                        <Grid item md="2">
                          <Box>
                            <div className={classes.mb2}>
                              <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                                {appraiserInfo.vendorCode ? (
                                  appraiserInfo.vendorCode
                                ) : (
                                  <div>&mdash;</div>
                                )}
                              </Typography>
                            </div>
                          </Box>
                        </Grid>
                        <Grid item md="3">
                          <Box>
                            <div className={classes.mb2}>
                              <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                                {appraiserInfo.companyName ? `${appraiserInfo.companyName}` : <div>&mdash;</div>}
                              </Typography>
                            </div>
                          </Box>
                        </Grid>
                        <Grid item md="2">
                          <Box>
                            <div className={classes.mb2}>
                              <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                                {a.mlsp ? formatMoney(a.mlsp) : <div>&mdash;</div>}
                              </Typography>
                            </div>
                          </Box>
                        </Grid>
                        <Grid item md="3">
                          <Box>
                            <div className={classes.mb2}>
                              <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                                {a.grossSalePrice ? formatMoney(a.grossSalePrice) : <div>&mdash;</div>}
                              </Typography>
                            </div>
                          </Box>
                        </Grid>
                        <Grid item md="2">
                          <Box>
                            <div className={classes.mb2}>
                              <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                                {a.appraisalStatusId ? statusOptions.find(s => s.id === a.appraisalStatusId).title : <div>&mdash;</div>}
                              </Typography>
                            </div>
                          </Box>
                        </Grid>
                      </>
                    );
                  })}

              {appraisalsBmas.length === 0 && (
                <>
                  <Grid item md="2">
                    <Box>
                      <div className={classes.mb2}>
                        <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                          <div>&mdash;</div>
                        </Typography>
                      </div>
                    </Box>
                  </Grid>
                  <Grid item md="3">
                    <Box>
                      <div className={classes.mb2}>
                        <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                          <div>&mdash;</div>
                        </Typography>
                      </div>
                    </Box>
                  </Grid>
                  <Grid item md="3">
                    <Box>
                      <div className={classes.mb2}>
                        <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                          <div>&mdash;</div>
                        </Typography>
                      </div>
                    </Box>
                  </Grid>
                  <Grid item md="2">
                    <Box>
                      <div className={classes.mb2}>
                        <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                          <div>&mdash;</div>
                        </Typography>
                      </div>
                    </Box>
                  </Grid>
                  <Grid item md="2">
                    <Box>
                      <div className={classes.mb2}>
                        <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                          <div>&mdash;</div>
                        </Typography>
                      </div>
                    </Box>
                  </Grid>
                </>
              )}

              <Box sx={{ width: '100%' }}>
                <hr />
              </Box>
              <Grid item md="1">
                <Box />
              </Grid>
              <Grid item md={appraisalsSelected ? '4' : '3'}>
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                      Spread Codes
                    </Typography>
                  </div>
                </Box>
              </Grid>
              <Grid item md="2">
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                      {appraisalsSelected ? 'Appraised Value Spread %' : 'MLSP Spread %'}
                    </Typography>
                  </div>
                </Box>
              </Grid>
              {!appraisalsSelected && (
                <Grid item md="2">
                  <Box>
                    <div className={classes.mb2}>
                      <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                        SLP Spread %
                      </Typography>
                    </div>
                  </Box>
                </Grid>
              )}
              <Grid item md={appraisalsSelected ? '5' : '2'}>
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                      {appraisalsSelected ? 'Average Appraised Value' : 'Average MLSP'}
                    </Typography>
                  </div>
                </Box>
              </Grid>
              {!appraisalsSelected && (
                <Grid item md="2">
                  <Box>
                    <div className={classes.mb2}>
                      <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                        Average SLP
                      </Typography>
                    </div>
                  </Box>
                </Grid>
              )}

              {appraisalsBmas.length > 0 &&
                groupAppraisals(appraisalsBmas).map(g => {
                  let suggestedListSpreadPercent =
                    g[0].grossSalePrice && g[1].grossSalePrice
                      ? Math.abs((1 - g[0].grossSalePrice / g[1].grossSalePrice) * 100).toFixed(2)
                      : null;
                  let appraisedValueSpreadPercent = g[0].mlsp && g[1].mlsp ? Math.abs((1 - g[0].mlsp / g[1].mlsp) * 100).toFixed(2) : null;

                  const appraiserOneInfo = vendors.find(b => b.vendorId === g[0].vendorId);
                  const appraiserTwoInfo = vendors.find(b => b.vendorId === g[1].vendorId);

                  return (
                    <>
                      <Grid item md="1">
                        <Box>
                          <Box sx={{ marginBottom: '20px' }}>
                            <Checkbox
                              name="spreadSelected"
                              label="Active"
                              sx={{ padding: '0px' }}
                              onChange={e => checkedSpread(e, g)}
                              checked={
                                appraisalsSelected
                                  ? appraisalSpreadSelectionStart &&
                                  appraisalSpreadSelectionEnd &&
                                  appraisalSpreadSelectionStart === g[0].homesaleAppraisalId &&
                                  appraisalSpreadSelectionEnd === g[1].homesaleAppraisalId
                                  : bmaSpreadSelectionStart &&
                                  bmaSpreadSelectionEnd &&
                                  bmaSpreadSelectionStart === g[0].homesaleAppraisalId &&
                                  bmaSpreadSelectionEnd === g[1].homesaleAppraisalId
                              }
                              disabled={false}
                            />
                          </Box>
                        </Box>
                      </Grid>
                      <Grid item md={appraisalsSelected ? '4' : '2'}>
                        <Box>
                          <div className={classes.mb2}>
                            <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>{`${appraiserOneInfo?.companyName || ''
                              } / ${appraiserTwoInfo?.companyName || ''}`}</Typography>
                          </div>
                        </Box>
                      </Grid>
                      <Grid item md="2">
                        <Box>
                          <div className={classes.mb2}>
                            <Typography
                              variant="body2"
                              sx={{
                                color: appraisedValueSpreadPercent && Number(appraisedValueSpreadPercent) > 5 ? 'red' : '#43423a',
                                fontWeight: 500,
                                fontSize: '1rem'
                              }}
                            >
                              {appraisedValueSpreadPercent ? appraisedValueSpreadPercent : <div>&mdash;</div>}
                            </Typography>
                          </div>
                        </Box>
                      </Grid>
                      {!appraisalsSelected && (
                        <>
                          <Grid item md="2">
                            <Box>
                              <div className={classes.mb2}>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    color: suggestedListSpreadPercent && Number(suggestedListSpreadPercent) > 5 ? 'red' : '#43423a',
                                    fontWeight: 500,
                                    fontSize: '1rem'
                                  }}
                                >
                                  {suggestedListSpreadPercent ? suggestedListSpreadPercent : <div>&mdash;</div>}
                                </Typography>
                              </div>
                            </Box>
                          </Grid>
                        </>
                      )}
                      <Grid item md={appraisalsSelected ? '5' : '2'}>
                        <Box>
                          <div className={classes.mb2}>
                            <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                              {g[0].mlsp && g[1].mlsp ? (
                                formatMoney((g[0].mlsp + g[1].mlsp) / 2)
                              ) : (
                                <div>&mdash;</div>
                              )}
                            </Typography>
                          </div>
                        </Box>
                      </Grid>
                      {!appraisalsSelected && (
                        <>
                          <Grid item md="2">
                            <Box>
                              <div className={classes.mb2}>
                                <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                                  {g[0].grossSalePrice && g[1].grossSalePrice ? (
                                    formatMoney((g[0].grossSalePrice + g[1].grossSalePrice) / 2)
                                  ) : (
                                    <div>&mdash;</div>
                                  )}
                                </Typography>
                              </div>
                            </Box>
                          </Grid>
                        </>
                      )}
                    </>
                  );
                })}

              {appraisalsBmas.length === 0 && (
                <>
                  <Grid item md="1">
                    <Box>
                      <div className={classes.mb2}>
                        <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                          <div>&mdash;</div>
                        </Typography>
                      </div>
                    </Box>
                  </Grid>
                  <Grid item md="3">
                    <Box>
                      <div className={classes.mb2}>
                        <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                          <div>&mdash;</div>
                        </Typography>
                      </div>
                    </Box>
                  </Grid>
                  <Grid item md="3">
                    <Box>
                      <div className={classes.mb2}>
                        <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                          <div>&mdash;</div>
                        </Typography>
                      </div>
                    </Box>
                  </Grid>
                  {!appraisalsSelected && (
                    <>
                      <Grid item md="3">
                        <Box>
                          <div className={classes.mb2}>
                            <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                              <div>&mdash;</div>
                            </Typography>
                          </div>
                        </Box>
                      </Grid>
                      <Grid item md="2">
                        <Box>
                          <div className={classes.mb2}>
                            <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                              <div>&mdash;</div>
                            </Typography>
                          </div>
                        </Box>
                      </Grid>
                    </>
                  )}
                </>
              )}
            </Grid>
          </Stack>
        </div>
        {isLoading && (
          <DialogActions sx={{ p: '1.25rem' }}>
            <Spinner />
          </DialogActions>
        )}
        {!isLoading && (
          <DialogActions sx={{ p: '1.25rem' }}>
            <Button onClick={onClose}>Cancel</Button>
            <Button color="primary" type="submit" variant="contained" disabled={!isDirty}>
              Save
            </Button>
          </DialogActions>
        )}
      </form>
    </Dialog>
  );
};

const SpreadSelectorCard = props => {
  const [isLoading, setIsLoading] = useState(false);
  const [editingModalOpen, setEditingModalOpen] = useState(false);

  const classes = useStyles();

  const theme = createTheme({
    palette: {
      primary: COLOR_PRIMARY,
      secondary: COLOR_SECONDARY,
      warning: COLOR_WARNING
    }
  });

  const { appraisalsBmas, appraisalsSelected, homesaleInfo, isReadOnly, statusOptions, vendors, fileId, vendorTypes } = props;

  const updateFields = async values => {
    setIsLoading(true);

    let newVals = { ...homesaleInfo };

    newVals.appraisalSpreadSelectionStart = values.appraisalSpreadSelectionStart;
    newVals.appraisalSpreadSelectionEnd = values.appraisalSpreadSelectionEnd;
    newVals.bmaSpreadSelectionStart = values.bmaSpreadSelectionStart;
    newVals.bmaSpreadSelectionEnd = values.bmaSpreadSelectionEnd;

    let resp = await props.updateSpreadSelection(fileId, newVals);
    if (resp.type === UPDATE_HOMESALE_INFO_FAILURE) {
      props.showToast('Failed to select spread, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      return false;
    }

    setIsLoading(false);
    return true;
  };

  const handleSaveEdits = async values => {
    // Send update call to parent to update and refresh values.
    const resp = await updateFields(values);
    if (!resp) {
      showToast('Failed to update moving dates data, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      return;
    }
    setEditingModalOpen(false); //required to exit editing mode and close modal
  };

  const groupAppraisals = appraisalBmasTemp => {
    let pairs = [];

    for (let i = 0; i < appraisalBmasTemp.length; i++) {
      for (let j = i + 1; j < appraisalBmasTemp.length; j++) {
        pairs.push([appraisalBmasTemp[i], appraisalBmasTemp[j]]);
      }
    }

    return pairs;
  };

  return (
    <ThemeProvider theme={theme}>
      <Card className={classes.card}>
        <Box>
          <CardContent className={classes.cardContainer}>
            <div className="row justify-space-between align-center">
              <div className={classes.iconRow}>
                <Tooltip title="Estimates" key="Estimates" placement="right">
                  <FontAwesomeIcon icon={['fas', 'money-bill-trend-up']} size="2x" />
                </Tooltip>
                <Typography variant="h5" sx={{ paddingLeft: '20px', fontSize: '1.3125rem', fontWeight: 'bold' }}>
                  Spread Selection
                </Typography>
              </div>
              {!isReadOnly && (
                <Fab className={classes.iconOverlayImg} color="primary" size="small" onClick={() => setEditingModalOpen(true)}>
                  <FontAwesomeIcon size="1x" icon={['fas', 'pen']} color={theme.palette.common.white} />
                </Fab>
              )}
            </div>
          </CardContent>
          <CardContent sx={{ padding: '10px', marginLeft: '30px' }}>
            <Grid container spacing={2}>
              <Grid item md="2">
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                      Codes
                    </Typography>
                  </div>
                </Box>
              </Grid>
              <Grid item md="3">
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                      Name
                    </Typography>
                  </div>
                </Box>
              </Grid>
              <Grid item md={appraisalsSelected ? '5' : '2'}>
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                      {appraisalsSelected ? 'Appraised Value' : 'MLSP'}
                    </Typography>
                  </div>
                </Box>
              </Grid>
              {!appraisalsSelected && (
                <Grid item md="3">
                  <Box>
                    <div className={classes.mb2}>
                      <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                        SLP
                      </Typography>
                    </div>
                  </Box>
                </Grid>
              )}

              <Grid item md="2">
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                      Status
                    </Typography>
                  </div>
                </Box>
              </Grid>

              {appraisalsBmas.length > 0 &&
                appraisalsBmas.map(a => {
                  const appraiserInfo = vendors.find(b => b.vendorId === a.vendorId);
                  return (
                    <>
                      <Grid item md="2">
                        <Box>
                          <div className={classes.mb2}>
                            <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                              {appraiserInfo && appraiserInfo.vendorCode ? (
                                appraiserInfo.vendorCode
                              ) : (
                                <div>&mdash;</div>
                              )}
                            </Typography>
                          </div>
                        </Box>
                      </Grid>
                      <Grid item md="3">
                        <Box>
                          <div className={classes.mb2}>
                            <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                              {appraiserInfo && appraiserInfo.companyName ? appraiserInfo.companyName : <div>&mdash;</div>}
                            </Typography>
                          </div>
                        </Box>
                      </Grid>
                      <Grid item md="2">
                        <Box>
                          <div className={classes.mb2}>
                            <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                              {a.mlsp ? formatMoney(a.mlsp) : <div>&mdash;</div>}
                            </Typography>
                          </div>
                        </Box>
                      </Grid>
                      {!appraisalsSelected && (
                        <Grid item md="3">
                          <Box>
                            <div className={classes.mb2}>
                              <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                                {a.grossSalePrice ? formatMoney(a.grossSalePrice) : <div>&mdash;</div>}
                              </Typography>
                            </div>
                          </Box>
                        </Grid>
                      )}
                      {appraisalsSelected && (
                        <Grid item md="3">
                          <Box>
                            <div className={classes.mb2}>
                              <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                                {' '}
                              </Typography>
                            </div>
                          </Box>
                        </Grid>
                      )}
                      <Grid item md="2">
                        <Box>
                          <div className={classes.mb2}>
                            <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                              {a.appraisalStatusId ? statusOptions.find(s => s.id === a.appraisalStatusId).title : <div>&mdash;</div>}
                            </Typography>
                          </div>
                        </Box>
                      </Grid>
                    </>
                  );
                })}

              {appraisalsBmas.length === 0 && (
                <>
                  <Grid item md="2">
                    <Box>
                      <div className={classes.mb2}>
                        <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                          <div>&mdash;</div>
                        </Typography>
                      </div>
                    </Box>
                  </Grid>
                  <Grid item md="3">
                    <Box>
                      <div className={classes.mb2}>
                        <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                          <div>&mdash;</div>
                        </Typography>
                      </div>
                    </Box>
                  </Grid>
                  <Grid item md="3">
                    <Box>
                      <div className={classes.mb2}>
                        <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                          <div>&mdash;</div>
                        </Typography>
                      </div>
                    </Box>
                  </Grid>
                  {!appraisalsSelected && (
                    <Grid item md="2">
                      <Box>
                        <div className={classes.mb2}>
                          <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                            <div>&mdash;</div>
                          </Typography>
                        </div>
                      </Box>
                    </Grid>
                  )}
                  {appraisalsSelected && (
                    <Grid item md="3">
                      <Box>
                        <div className={classes.mb2}>
                          <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                            {' '}
                          </Typography>
                        </div>
                      </Box>
                    </Grid>
                  )}
                  <Grid item md="2">
                    <Box>
                      <div className={classes.mb2}>
                        <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                          <div>&mdash;</div>
                        </Typography>
                      </div>
                    </Box>
                  </Grid>
                </>
              )}

              <Box sx={{ width: '100%' }}>
                <hr />
              </Box>

              <Grid item md="1">
                <Box />
              </Grid>
              <Grid item md={appraisalsSelected ? '4' : '3'}>
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                      Spread Codes
                    </Typography>
                  </div>
                </Box>
              </Grid>
              <Grid item md={"2"}>
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                      {appraisalsSelected ? 'Appraised Value Spread %' : 'MLSP Spread %'}
                    </Typography>
                  </div>
                </Box>
              </Grid>
              {!appraisalsSelected && (
                <Grid item md="2">
                  <Box>
                    <div className={classes.mb2}>
                      <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                        SLP Spread %
                      </Typography>
                    </div>
                  </Box>
                </Grid>
              )}

              <Grid item md={appraisalsSelected ? '5' : '2'}>
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                      {appraisalsSelected ? 'Average Appraised Value' : 'Average MLSP'}
                    </Typography>
                  </div>
                </Box>
              </Grid>
              {!appraisalsSelected && (
                <Grid item md="2">
                  <Box>
                    <div className={classes.mb2}>
                      <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                        Average SLP
                      </Typography>
                    </div>
                  </Box>
                </Grid>
              )}

              {appraisalsBmas.length > 0 &&
                groupAppraisals(appraisalsBmas).map(g => {
                  let suggestedListSpreadPercent =
                    g[0].grossSalePrice && g[1].grossSalePrice
                      ? Math.abs((1 - g[0].grossSalePrice / g[1].grossSalePrice) * 100).toFixed(2)
                      : null;
                  let appraisedValueSpreadPercent = g[0].mlsp && g[1].mlsp ? Math.abs((1 - g[0].mlsp / g[1].mlsp) * 100).toFixed(2) : null;

                  const appraiserOneInfo = vendors.find(b => b.vendorId === g[0].vendorId);
                  const appraiserTwoInfo = vendors.find(b => b.vendorId === g[1].vendorId);

                  return (
                    <>
                      <Grid item md="1">
                        <Box>
                          <Box sx={{ marginBottom: '20px' }}>
                            <Checkbox
                              name="spreadSelected"
                              label="Active"
                              sx={{ padding: '0px' }}
                              checked={
                                appraisalsSelected
                                  ? homesaleInfo &&
                                  homesaleInfo.appraisalSpreadSelectionStart === g[0].homesaleAppraisalId &&
                                  homesaleInfo.appraisalSpreadSelectionEnd === g[1].homesaleAppraisalId
                                  : homesaleInfo &&
                                  homesaleInfo.bmaSpreadSelectionStart === g[0].homesaleAppraisalId &&
                                  homesaleInfo.bmaSpreadSelectionEnd === g[1].homesaleAppraisalId
                              }
                              disabled={true}
                            />
                          </Box>
                        </Box>
                      </Grid>
                      <Grid item md={appraisalsSelected ? '4' : '3'}>
                        <Box>
                          <div className={classes.mb2}>
                            <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>{`${appraiserOneInfo ? appraiserOneInfo.companyName : ''
                              } / ${appraiserTwoInfo ? appraiserTwoInfo.companyName : ''
                              }`}</Typography>
                          </div>
                        </Box>
                      </Grid>
                      <Grid item md="2">
                        <Box>
                          <div className={classes.mb2}>
                            <Typography
                              variant="body2"
                              sx={{
                                color: appraisedValueSpreadPercent && Number(appraisedValueSpreadPercent) > 5 ? 'red' : '#43423a',
                                fontWeight: 500,
                                fontSize: '1rem'
                              }}
                            >
                              {appraisedValueSpreadPercent ? appraisedValueSpreadPercent : <div>&mdash;</div>}
                            </Typography>
                          </div>
                        </Box>
                      </Grid>
                      {!appraisalsSelected && (
                        <Grid item md="2">
                          <Box>
                            <div className={classes.mb2}>
                              <Typography
                                variant="body2"
                                sx={{
                                  color: suggestedListSpreadPercent && Number(suggestedListSpreadPercent) > 5 ? 'red' : '#43423a',
                                  fontWeight: 500,
                                  fontSize: '1rem'
                                }}
                              >
                                {suggestedListSpreadPercent ? suggestedListSpreadPercent : <div>&mdash;</div>}
                              </Typography>
                            </div>
                          </Box>
                        </Grid>
                      )}


                      <Grid item md={appraisalsSelected ? '5' : '2'}>
                        <Box>
                          <div className={classes.mb2}>
                            <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                              {g[0].mlsp && g[1].mlsp ? (
                                formatMoney((g[0].mlsp + g[1].mlsp) / 2)
                              ) : (
                                <div>&mdash;</div>
                              )}
                            </Typography>
                          </div>
                        </Box>
                      </Grid>
                      {!appraisalsSelected && (
                        <Grid item md="2">
                          <Box>
                            <div className={classes.mb2}>
                              <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                                {g[0].grossSalePrice && g[1].grossSalePrice ? (
                                  formatMoney((g[0].grossSalePrice + g[1].grossSalePrice) / 2)
                                ) : (
                                  <div>&mdash;</div>
                                )}
                              </Typography>
                            </div>
                          </Box>
                        </Grid>
                      )}

                    </>
                  );
                })}

              {appraisalsBmas.length === 0 && (
                <>
                  <Grid item md="1">
                    <Box>
                      <div className={classes.mb2}>
                        <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                          <div>&mdash;</div>
                        </Typography>
                      </div>
                    </Box>
                  </Grid>
                  <Grid item md="3">
                    <Box>
                      <div className={classes.mb2}>
                        <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                          <div>&mdash;</div>
                        </Typography>
                      </div>
                    </Box>
                  </Grid>
                  <Grid item md="3">
                    <Box>
                      <div className={classes.mb2}>
                        <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                          <div>&mdash;</div>
                        </Typography>
                      </div>
                    </Box>
                  </Grid>
                  <Grid item md="3">
                    <Box>
                      <div className={classes.mb2}>
                        <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                          <div>&mdash;</div>
                        </Typography>
                      </div>
                    </Box>
                  </Grid>
                  <Grid item md="2">
                    <Box>
                      <div className={classes.mb2}>
                        <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                          <div>&mdash;</div>
                        </Typography>
                      </div>
                    </Box>
                  </Grid>
                </>
              )}
            </Grid>
          </CardContent>
        </Box>
      </Card>
      {editingModalOpen && (
        <EditCardModal
          classes={classes}
          tab={0}
          open={editingModalOpen}
          isLoading={isLoading}
          onClose={() => setEditingModalOpen(false)}
          onSubmit={handleSaveEdits}
          homesaleInfo={homesaleInfo}
          appraisalsBmas={appraisalsBmas}
          appraisalsSelected={appraisalsSelected}
          groupAppraisals={groupAppraisals}
          statusOptions={statusOptions}
          vendors={vendors}
          fileId={fileId}
          vendorTypes={vendorTypes}
        />
      )}
    </ThemeProvider>
  );
};

const mapStateToProps = state => {
  const { appraisalStatuses, vendorTypes } = state.enumerations.allEnums;

  return {
    statusOptions: appraisalStatuses || [],
    vendorTypes: vendorTypes || []
  };
};

export default compose(
  connect(mapStateToProps, {
    updateHomesaleInfo,
    postHomesaleInfo,
    showToast,
    updateSpreadSelection
  })
)(SpreadSelectorCard);
